
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtor/[alias]/[bookAlias]/read",
      function () {
        return require("private-next-pages/avtor/[alias]/[bookAlias]/read/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtor/[alias]/[bookAlias]/read"])
      });
    }
  